import { makeSendRequest } from "../../common/http";
import { CLOUD_API_DEPLOYED } from "../cloud_api/requests-browser";

export const LOGBOOK_URL = CLOUD_API_DEPLOYED ? "https://logbook.skyd.io" : "http://localhost:5000";

async function requestFromLogbook(url: string, init: RequestInit) {
  const response = await fetch(url, init);
  if (response.ok) {
    const data = await response.json();
    if (data.error) {
      throw new Error(data.error);
    } else {
      return data;
    }
  } else {
    throw new Error(`[${response.status}]: ${response.statusText}`);
  }
}

export const sendRequest = makeSendRequest(requestFromLogbook, LOGBOOK_URL);
